import { render, staticRenderFns } from "./all_head.vue?vue&type=template&id=4f053944&scoped=true&"
import script from "./all_head.vue?vue&type=script&lang=js&"
export * from "./all_head.vue?vue&type=script&lang=js&"
import style0 from "./all_head.vue?vue&type=style&index=0&id=4f053944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f053944",
  null
  
)

export default component.exports